import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import axios from 'axios';

export function EditPassword({ stateDetail }) {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');

  const { id } = useParams();
  const history = useHistory();

  return (
    <React.Fragment>
      <div className='container flex items-center justify-center py-5'>
        <div className='w-full'>
          <div className='card p-5'>
            <form className='w-full'>
              <div className='grid grid-cols-1 gap-4'>
                <br />
                <div>
                  <label
                    className='label block mb-2'
                    style={{ color: '#145488', float: 'revert', fontSize: 24 }}
                    htmlFor='title'
                  >
                    Change Password
                  </label>
                </div>
                <div>
                  <label className='label block mb-2' htmlFor='title'>
                    Old Password
                  </label>
                  <input id='title' type='text' className='form-control' />
                </div>
                <div>
                  <label className='label block mb-2' htmlFor='title'>
                    New Password
                  </label>
                  <input id='title' type='text' className='form-control' />
                </div>

                <div>
                  <label className='label block mb-2' htmlFor='title'>
                    Repeat New Passoword
                  </label>
                  <input id='title' type='text' className='form-control' />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
